import 'babel-polyfill';
import './bootstrap';

$(function() {
    $('form.logout').submit(function(e) {
        sessionStorage.clear();
    });

    $('a.new-window').click(function(e){
        e.preventDefault();

        window.open($(this).prop('href'));
    });

    $.ajax({
        url: "/order/api/session-timeout",
        context: document.body
    }).done(function(data) {
        if (data == null || data == undefined) {
            return;
        }
        data = JSON.parse(data);
        setTimeout(function() {
            alert('Session has timed out');
        }, data * 1000);
    });
});
